<template>
  <div>
    <v-row dense>
      <v-col>
        <v-text-field
          class="hideMessages"
          label="Search your training resources"
          single-line
          solo
          clearable
          prepend-inner-icon="search"
          v-model="search"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card>
      <template v-for="(category, i) in categoriesToDisplay">
        <resource-library-category
          :key="i"
          :category="category"
          :resources="
            filtered_resources.filter(x => x.pulseCategoryId == category.id)
          "
        ></resource-library-category>
        <v-divider
          :key="i + 'divider'"
          v-if="i < categoriesToDisplay.length - 1"
        ></v-divider>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceLibraryCategory from "@/components/resources/ResourceLibraryCategory";
export default {
  name: "ResourceLibrary",
  components: {
    ResourceLibraryCategory
  },
  props: {},
  data: () => ({
    loading: false,
    search: ""
  }),
  computed: {
    filtered_resources() {
      let resources = this.resources;

      if (this.search) {
        let search = this.search.toLowerCase();
        resources = resources.filter(
          x => x.title.toLowerCase().indexOf(search) >= 0
        );
      }
      return resources;
    },
    categoriesToDisplay() {
      let list = this._.cloneDeep(this.categories);
      list.push({ id: null, name: "Other" });

      let ids = this.filtered_resources.map(x => x.pulseCategoryId);
      return this._.uniq(
        list.filter(x => {
          return ids.includes(x.id);
        })
      );
    },
    ...mapGetters({
      resources: "resource/library",
      categories: "pulse/categories"
    })
  },
  created() {
    this.getResources();
  },
  methods: {
    getResources() {
      this.loading = true;
      Promise.all([this.$store.dispatch("resource/getLibraryResources")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading resources."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
